import HistoryUnitBetweenComparatorFilterConverter from "./HistoryUnitBetweenComparatorFilterConverter.js";
import HistoryUnitEqualsComparatorFilterConverter from "./HistoryUnitEqualsComparatorFilterConverter.js";
import HistoryUnitGreaterThanComparatorFilterConverter from "./HistoryUnitGreaterThanComparatorFilterConverter.js";
import HistoryUnitGreaterThanOrEqualComparatorFilterConverter from "./HistoryUnitGreaterThanOrEqualComparatorFilterConverter.js";
import HistoryUnitLessThanComparatorFilterConverter from "./HistoryUnitLessThanComparatorFilterConverter.js";
import HistoryUnitLessThanOrEqualComparatorFilterConverter from "./HistoryUnitLessThanOrEqualComparatorFilterConverter.js";
import HistoryUnitNotEqualsComparatorFilterConverter from "./HistoryUnitNotEqualsComparatorFilterConverter.js";
export default {
  install(molten) {
    HistoryUnitBetweenComparatorFilterConverter.create(molten);
    HistoryUnitEqualsComparatorFilterConverter.create(molten);
    HistoryUnitGreaterThanComparatorFilterConverter.create(molten);
    HistoryUnitLessThanComparatorFilterConverter.create(molten);
    HistoryUnitNotEqualsComparatorFilterConverter.create(molten);
    HistoryUnitGreaterThanOrEqualComparatorFilterConverter.create(molten);
    HistoryUnitLessThanOrEqualComparatorFilterConverter.create(molten);
  }
};